<template>
  <div class="slogan-bar">
    <p class="slogan">我们不生产信息，我们只是精准刊期的搬运工。</p>
    <p class="stats">
      <span>当日更新 {{ stats.today_update_count ?? 0 }} 期次</span>，
      <span>本周更新 {{ stats.week_update_count ?? 0 }} 期次</span>，
      <span>本周新增期刊 {{ stats.week_new_count ?? 0 }} 本</span>，
      <span>热门期刊 {{ stats.hot_count ?? 0 }} 本</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'SloganBar',
  props: {
    stats: { type: Object, default: () => ({}) }
  }
}
</script>

<style scoped>
.slogan-bar {
  background: var(--color-bg-slogan);
  color: #fff;
  padding: 14px 20px;
  text-align: center;
}
.slogan {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 500;
}
.stats {
  margin: 0;
  font-size: 13px;
  opacity: 0.95;
}
.stats span + span::before { content: '，'; }
@media (max-width: 768px) {
  .slogan-bar {
    padding: 10px 12px;
    padding-top: calc(10px + var(--safe-top));
  }
  .slogan { font-size: 14px; margin-bottom: 4px; }
  .stats { font-size: 12px; }
}
</style>
